import { createFileRoute, Outlet } from '@tanstack/react-router';

// 单个 quiz 的布局。信息页（index）、尝试页
// （attempts/$attemptId）、教师班级尝试列表（attempts）和
// 评分页（grade/$attemptId）均通过此 Outlet 渲染。保持纯
// 透传使子组件不获得额外容器——没有它嵌套的
// attempt + grade 页面永远不会挂载。
export const Route = createFileRoute('/_learner/courses_/$id/quizzes/$quizId')({
  component: () => <Outlet />,
});
